import api from './api';

export interface UserProfile {
    id: string;
    name: string;
    email: string;
    personalReferralCode?: string;
}

export interface LoginResponse {
    token: string;
    name: string;
    email: string;
}

export const authService = {
    login: async (email: string, password: string): Promise<LoginResponse> => {
        try {
            const response = await api.post<LoginResponse>('/api/auth/login/user', {
                email,
                password,
            });
            return response.data;
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error de conexión. Por favor, inténtalo de nuevo.');
        }
    },

    loginWithGoogle: async (idToken: string): Promise<LoginResponse> => {
        try {
            const response = await api.post<LoginResponse>('/api/auth/google', { idToken });
            return response.data;
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error al iniciar sesión con Google. Por favor, inténtalo de nuevo.');
        }
    },


    forgotPassword: async (email: string): Promise<void> => {
        try {
            await api.post('/api/auth/forgot-password', { email, role: 'User' });
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error al enviar el correo. Por favor, inténtalo de nuevo.');
        }
    },

    resetPassword: async (email: string, otpCode: string, newPassword: string): Promise<void> => {
        try {
            await api.post('/api/auth/reset-password', {
                email,
                otpCode,
                newPassword,
                role: 'User',
            });
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error al restablecer la contraseña. Verifica el código e inténtalo de nuevo.');
        }
    },

    register: async (
        name: string,
        email: string,
        password: string,
        referralCode?: string,
        targetBrandId?: string
    ): Promise<void> => {
        try {
            const payload = {
                name,
                email,
                password,
                ...(referralCode && { referralCode }),
                ...(targetBrandId && { targetBrandId })
            };
            await api.post('/api/auth/register/user', payload);
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error al crear la cuenta. Por favor, inténtalo de nuevo.');
        }
    },

    getUserProfile: async (): Promise<UserProfile> => {
        try {
            const response = await api.get<UserProfile>('/api/users/me');
            return response.data;
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error al obtener el perfil.');
        }
    },

    updateUserProfile: async (name: string, email: string): Promise<void> => {
        try {
            await api.put('/api/users/me', { name, email });
        } catch (error: any) {
            if (error.response?.status === 400 || error.response?.status === 409) {
                const msg =
                    error.response?.data?.errors?.Email?.[0] ||
                    error.response?.data?.errors?.Name?.[0] ||
                    'El correo electrónico ya está en uso.';
                throw new Error(msg);
            }
            throw new Error('Error al actualizar el perfil. Por favor, inténtalo de nuevo.');
        }
    },
};
